const FormAgreement = {

    init() {
        this.el = $('[component="FormAgreement"]');
        if (!this.el.length) return;

        this.marketing = this.el.find('.marketing');
        this.checkboxMarketing = this.marketing.find('input[type="checkbox"]');
        this.inputMarketing = this.marketing.find('[name="agreement_marketing"]');
        this.bind();
    },

    bind() {
        this.checkboxMarketing.click((evt) => {
            const val = $(evt.currentTarget).is(":checked") ? 'on' : 'off';
            this.inputMarketing.val(val)
        })
    },
}

export default FormAgreement;